/** @jsxImportSource @emotion/react */
import { selectPlayers } from 'modules/main/store/main-page';
import Scorers from 'modules/main/ui/components/section/components/scorers/scorers';
import ValueGroup from 'modules/main/ui/components/section/components/value-group/value-group';
import Section from 'modules/main/ui/components/section/section';
import { Pages } from 'modules/navigation/domain/enums/pages';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { theme } from 'styles/theme/theme';
import type { DivProps } from 'typings';
import UserIcon from 'ud-ui/components/icon/user-icon';
import Text from 'ud-ui/components/text';

interface IProps extends DivProps {
  loading?: boolean;
}

function SectionPlayers(props: IProps) {
  const { loading, ...rest } = props;
  const navigate = useNavigate();
  const { total, declared, bestScorers } = useSelector(selectPlayers);

  const values = [
    { label: 'всего', value: total.toString() },
    { label: 'заявлены', value: declared.toString() },
  ];

  return (
    <Section
      icon={<UserIcon />}
      header="Игроки"
      buttonText="Добавить игроков"
      onClickButton={() => navigate(Pages.PLAYERS.CREATE)}
      onClickExtend={() => navigate(Pages.PLAYERS.INDEX)}
      isShowButton={total < 1}
      loading={loading}
      {...rest}
    >
      <ValueGroup values={values} className="mb-5" />
      {bestScorers.length ? (
        <div className="flex flex-col gap-5">
          <div className="flex flex-col">
            <Text isNew type="body-1" color={theme.colors.Gray}>
              Лучшие бомбардиры
            </Text>
            <Text isNew type="subtitle-2" color={theme.colors.WhiteGray}>
              Больше всех забили голов
            </Text>
          </div>
          <Scorers scorers={bestScorers} />
        </div>
      ) : (
        <div className="flex flex-col">
          <Text isNew type="body-1" color={theme.colors.Gray}>
            Лучшие бомбардиры
          </Text>
          <Text isNew type="subtitle-2" color={theme.colors.WhiteGray}>
            В списке нет игроков
          </Text>
        </div>
      )}
    </Section>
  );
}

export default SectionPlayers;
